import { Template } from "@/lib/types";
import { ExtendedObject } from "../types/objectTypes";
import { initBackgroundImageOnCanvas } from "./backgroundUtils";
import { findViewportObjectInFabricJson, createStaticCanvas } from "./canvasUtils";
import { isBackgroundImage } from "./shapeUtils";

export function renderStrokeForCircle(ctx: CanvasRenderingContext2D, radius: number) {
  ctx.beginPath();
  ctx.arc(0, 0, radius, 0, 2 * Math.PI);
  ctx.stroke();
}

export async function renderImageFromCanvasData(
  canvasData: Template["canvas_data"],
  options: { multiplier: number } = { multiplier: 0.5 }
) {
  if (!canvasData?.objects) return;

  const viewportObject = findViewportObjectInFabricJson(canvasData);

  if (!viewportObject) {
    console.warn("[renderImageFromCanvasData] there is no viewport in fabric data");

    return;
  }

  if (!viewportObject.width || !viewportObject.height) {
    console.warn(`[renderImageFromCanvasData] couldn't detect dimensions for the viewport`, {
      width: viewportObject.width,
      height: viewportObject.height,
    });

    return;
  }

  const previewCanvas = createStaticCanvas(viewportObject.width, viewportObject.height);

  return createImageFromFabricData(previewCanvas, canvasData, { multiplier: options.multiplier });
}

type StaticCanvas = ReturnType<typeof createStaticCanvas>;
type CreatingImageOptions = Partial<Parameters<StaticCanvas["toDataURL"]>["0"]>;

async function createImageFromFabricData(
  previewCanvas: StaticCanvas,
  data: Template["canvas_data"],
  options?: CreatingImageOptions
) {
  return new Promise<string>((resolve) => {
    previewCanvas.loadFromJSON(data, () => {
      previewCanvas.getObjects().forEach((obj: ExtendedObject) => {
        if (isBackgroundImage(obj)) {
          initBackgroundImageOnCanvas(obj);
        }
      });

      const dataURL = previewCanvas.toDataURL({
        format: "png",
        ...options,
      });

      resolve(dataURL);
    });
  });
}
